"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InformationController = function InformationController(Information, Util, growl, $uibModal, Upload, SERVER_URL) {
  "ngInject";

  (0, _classCallCheck3.default)(this, InformationController);
  var vm = this;
  vm.items = [];
  vm.language = "IT";
  vm.summernoteOptions = Util.getSummernoteOptions();
  vm.addItem = addItem;
  vm.saveItem = saveItem;
  vm.deleteItem = deleteItem;
  vm.imageUpload = imageUpload;
  init();

  function init() {
    Information.getList().then(function (res) {
      vm.items = _lodash2.default.filter(res.data, function (o) {
        return o.information.active === true;
      });
      console.log("Items", vm.items);
    });
  }

  function addItem() {
    $uibModal.open({
      component: 'addNew',
      size: 'lg'
    }).result.then(function (closed) {
      init();
    });
  }

  function saveItem(itemToSave) {
    Information.putString(itemToSave).then(function (res) {
      vm.newItem = null;
      growl.success("Sezione modificata con successo");
    }, function (err) {
      growl.error("Errore modifica sezione");
    });
  }

  function deleteItem(itemToDelete) {
    $uibModal.open({
      component: 'confirmDialog',
      windowClass: 'modal-mini modal-primary',
      resolve: {
        message: function message() {
          return "Confermi di voler cancellare questa sezione?";
        }
      }
    }).result.then(function () {
      Information.deleteItem(itemToDelete).then(function (res) {
        growl.success("Sezione cancellata con successo!");
        init();
      }, function (err) {
        growl.error("Errore cancellazione sezione");
      });
    });
  }
  function imageUpload(images, informationIndex, langIndex) {
    Upload.upload({
      url: SERVER_URL + '/images/public-image',
      data: {
        file: images[0]
      }
    }).then(function (resp) {
      var imgNode = $("<img>").attr('src', resp.data.url)[0];
      var container = $('#summernote-' + langIndex + '-' + informationIndex);
      container.summernote('insertNode', imgNode);
      vm.items[informationIndex].faqstringsList[langIndex].body = container.summernote('code');
      $timeout(function () {}, 2000);
    }, function (resp) {
      console.log('Error status: ' + resp.status);
    }, function (evt) {});
  }
};

exports.default = InformationController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/information/information.controller.js